export interface IAuthState {
  isAuthenticated: boolean;
  token: string;
  menu: string[];
  paths: string[];
  username: string;
  curUserObject: any;
  systemUsers: string[]
}

export const AuthDefaultState = (): IAuthState => {
  return {
    isAuthenticated: false,
    token: "",
    menu: [],
    paths: [],
    username: "",
    curUserObject: null,
    systemUsers: []
  };
};
